import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'
import DealerRepositoriesFactory from '../Repositories/factory.js'
import {GetIsMakeHiredRequest} from '../Requests/GetIsMakeHiredRequest.js'

/**
 * @implements UseCase
 */
class GetIsMakeHiredDealerUseCase extends UseCase {
  #repository
  #isMotos

  constructor({repository, isMotos}) {
    super()
    this.#repository = repository
    this.#isMotos = isMotos
  }

  static create({config}) {
    return new GetIsMakeHiredDealerUseCase({
      repository: DealerRepositoriesFactory.hTTPDealerRepository({config}),
      isMotos: config.get('APP_NAME') === config.get('APP_NAME_MOTOS')
    })
  }

  @tracer({metric: 'GetIsMakeHiredDealerUseCase#execute'})
  @AsyncInlineError()
  async execute(params = {}) {
    if (this.#isMotos) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }
    const getIsMakeHiredRequest = GetIsMakeHiredRequest.create({makeId: params.makeId})

    const [error, response] = await this.#repository.getIsMakeHired({getIsMakeHiredRequest})

    if (error) return Promise.reject(error)

    return response
  }
}

export default GetIsMakeHiredDealerUseCase.create
